module.exports = __webpack_public_path__ + "media/fonts/calibri/Calibri-Bold-8c8905b9e5a727f74debd5a1519544fd.ttf";